/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { HelpModalComponentArgs } from 'cio/components/help-modal';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import AnalyticsService from 'cio/services/analytics';

export default class BatchUpdatePeopleLimitFeedbackForm extends Component<HelpModalComponentArgs> {
  @service analytics!: AnalyticsService;

  @tracked suggestion = '';

  get submitDisabled() {
    if (this.args.disabled) {
      return true;
    }

    if (isEmpty(this.suggestion)) {
      return true;
    }

    return false;
  }

  get disabledTooltipContent() {
    if (isEmpty(this.suggestion)) {
      return 'Please enter feedback';
    }

    return '';
  }

  @action
  onInsert() {
    this.analytics.track('user', 'feedback_request_started', {
      source: 'Batch Update Limit',
    });
  }

  @action
  onSubmit(e: Event) {
    e.preventDefault();

    this.args.onSubmit({
      criticism: "What's your use case for updating more than 1,000 people at once?",
      praise: this.suggestion,
    });
  }
}
